import { shiftTypeObj } from '../../helpers/data';
import requestUtil from '../../helpers/requestUtil';
import { setHeaderState } from '../common/Header/slice';
import { setLoading } from '../common/Loader/slice';
import * as Toasts from '../common/Toastify';
import {
  setCalenderData,
  setFailureLogs,
  setJobEncounterOccurreneUpdateList,
  setMasterData,
} from '../JobOpportunity/slice';
import { updateSharedSlice } from '../shared/sharedSlice';
import {
  patchFilterFieldData,
  reset,
  resetShiftsCoverage,
  setDeleteEmployerReasons,
  setError,
  setFilterData,
  setGridLoader,
  setGrouping,
  setJobInfoForDailyOccurance,
  setLoadingFlagDecrement,
  setLoadingFlagIncrement,
  setMatchincandidateInfo,
  setMultishiftClaimDeail,
  setMultishiftClaimedFalg,
  setMultishiftUnClaimByEmpFalg,
  setPage,
  setSelectedOption,
  setSorting,
  setUnclaimEmployerReasons,
  shiftsCoverageFailed,
  updateAwaitingShiftsCoverageListings,
  updateClearFilter,
  updateCompletedShiftsCoverageListings,
  updateDailyEncounterInfo,
  updateMasterDatas,
  updateMultiShiftJobInfo,
  updateOpenShiftsCoverageListings,
  updatePageSize,
  updateShiftsCoverageListings,
  updateShiftsType,
  updatePaymentShiftsCoverageListings,
  updateMultiShiftFilterData,
  updateShiftsCorrectionsListings
} from './slice';

const isEmpty = (str) => {
  return !str || '' === str.trim();
};
const createLoadRequest = (
  page,
  pageSize,
  empId,
  fromDate,
  toDate,
  location,
  searchText,
  sortOrder,
  sortColumn,
  shiftsType,
  jobUniqueId,
  jobsShiftUniqueId
) => {
  const request = {
    page: page,
    pageSize: pageSize,
    employerUniqueId: `${empId}`,
    ShiftsType: shiftsType,
  };
  if (!isEmpty(fromDate)) {
    request.fromDateTime = fromDate;
  }
  if (!isEmpty(toDate)) {
    request.toDateTime = toDate;
  }
  if (location) {
    request.location = location?.id;
  }
  if (!isEmpty(searchText)) {
    request.searchText = searchText;
  }
  if (sortColumn && sortColumn !== '' && sortOrder && sortOrder !== '') {
    request.sortOrder = sortOrder;
    request.sortColumn = sortColumn;
  }
  if (jobUniqueId) {
    request.jobUniqueId = jobUniqueId;
  }
  if (jobsShiftUniqueId) {
    request.jobsShiftUniqueId = jobsShiftUniqueId;
  }
  return request;
};

export function loadShiftsCoverageListings({ url, empId, pageToLoad }) {
  return async (dispatch, getState) => {
    // dispatch(setLoading(true));
    // dispatch(setLoading(true));
    // dispatch(setGridLoader(true));
    dispatch(setLoadingFlagIncrement());
    try {
      const state = getState();
      const {
        page,
        pageSize,
        sortOrder,
        sortColumn,
        filterFields,
        shiftsType,
      } = state.shiftsCoverage;
      //shiftsType=1;
      let request = createLoadRequest(
        pageToLoad || page,
        pageSize,
        empId,
        filterFields.fromDate,
        filterFields.toDate,
        filterFields.location,
        filterFields.searchText,
        sortOrder,
        sortColumn,
        shiftsType
      );
      if (filterFields?.department?.length) {
        // request.departments = departments;
        request = { ...request, department: filterFields?.department?.map(deps => deps?.id) }
      }
      if (filterFields?.location?.length) {
        request = { ...request, LocationIdlist: filterFields?.location?.map(location => location?.id) }
      }
      const shiftsCoverageListing = await requestUtil(
        `${url}/Employers/get-all-shifts`,
        'POST',
        request
      );
      if (shiftsCoverageListing && shiftsCoverageListing?.jobShifts && shiftsCoverageListing?.jobShifts?.length) {
        shiftsCoverageListing.jobShifts.forEach((item, index) => {
          item.id = (index + 1) + (page - 1) * pageSize
        })
      }
      dispatch(
        updateShiftsCoverageListings({
          data: shiftsCoverageListing,
          page: pageToLoad || page,
        })
      );
      // dispatch(setGridLoader(false));
      // dispatch(setLoading(false));
    } catch (error) {
      dispatch(shiftsCoverageFailed(error.message));
      // dispatch(setLoading(false));
      // dispatch(setGridLoader(false));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function loadOpenShiftsCoverageListings({ url, empId, pageToLoad }) {
  return async (dispatch, getState) => {
    dispatch(setLoadingFlagIncrement());
    // dispatch(setLoading(true));
    // dispatch(setGridLoader(true));
    try {
      const state = getState();
      const { page, pageSize, sortOrder, sortColumn, filterFields } =
        state.shiftsCoverage;
      //shiftsType=1;
      let request = createLoadRequest(
        pageToLoad || page,
        pageSize,
        empId,
        filterFields.fromDate,
        filterFields.toDate,
        filterFields.location,
        filterFields.searchText,
        sortOrder,
        sortColumn,
        2
      );
      if (filterFields?.department?.length) {
        // request.departments = departments;
        request = { ...request, department: filterFields?.department?.map(deps => deps?.id) }
      }

      if (filterFields?.location?.length) {
        request = { ...request, LocationIdlist: filterFields?.location?.map(location => location?.id) }
      }

      const openShiftsCoverageListing = await requestUtil(
        `${url}/Employers/get-open-shifts`,
        'POST',
        request
      );
      if (openShiftsCoverageListing && openShiftsCoverageListing?.jobShifts && openShiftsCoverageListing?.jobShifts?.length) {
        openShiftsCoverageListing.jobShifts.forEach((item, index) => {
          item.id = (index + 1) + (page - 1) * pageSize
        })
      } 
      dispatch(
        updateOpenShiftsCoverageListings({
          data: openShiftsCoverageListing,
          page: pageToLoad || page,
        })
      );
      // dispatch(setGridLoader(false));
      // dispatch(setLoading(false));
    } catch (error) {
      dispatch(shiftsCoverageFailed(error.message));
      // dispatch(setLoading(false));
      // dispatch(setGridLoader(false));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function loadPaymentShiftsCoverageListings({ url, empId, pageToLoad }) {
  return async (dispatch, getState) => {
    dispatch(setLoadingFlagIncrement());
    // dispatch(setLoading(true));
    // dispatch(setGridLoader(true));
    try {
      const state = getState();
      const { page, pageSize, sortOrder, sortColumn, filterFields } =
        state.shiftsCoverage;
      //shiftsType=1;
      let request = createLoadRequest(
        pageToLoad || page,
        pageSize,
        empId,
        filterFields.fromDate,
        filterFields.toDate,
        filterFields.location,
        filterFields.searchText,
        sortOrder,
        sortColumn,
        5
      );
      if (filterFields?.department?.length) {
        // request.departments = departments;
        request = { ...request, department: filterFields?.department?.map(deps => deps?.id) }
      }
      if (filterFields?.location?.length) {
        request = { ...request, LocationIdlist: filterFields?.location?.map(location => location?.id) }
      }
      const openShiftsCoverageListing = await requestUtil(
        `${url}/Employers/get-shift-awaiting-payment-v2`,
        'POST',
        request
      );
      if (openShiftsCoverageListing && openShiftsCoverageListing?.jobShifts && openShiftsCoverageListing?.jobShifts?.length) {
        openShiftsCoverageListing.jobShifts.forEach((item, index) => {
          item.id = (index + 1) + (page - 1) * pageSize
        })
      }
      dispatch(
        updatePaymentShiftsCoverageListings({
          data: openShiftsCoverageListing,
          page: pageToLoad || page,
        })
      );
      // dispatch(setGridLoader(false));
      // dispatch(setLoading(false));
    } catch (error) {
      dispatch(shiftsCoverageFailed(error.message));
      // dispatch(setLoading(false));
      // dispatch(setGridLoader(false));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function loadMultiShiftJobInfo({
  url,
  sortOrder,
  sortColumn,
  jobsShiftUniqueId,
  multishiftJobInfoFilter
}) {
  return async (dispatch, getState) => {
    // dispatch(setLoading(true));
    // dispatch(setGridLoader(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const state = getState();
      const { page, pageSize } = state.shiftsCoverage;
      //shiftsType=1;
      const params = {
        page,
        pageSize,
        sortColumn,
        sortOrder,
        jobsShiftUniqueId,
        shiftsType: 2,
        multishiftJobInfoFilter
      };
      const multiShiftsCoverageListing = await requestUtil(
        `${url}/employers/multishift-occurance-getjobs-for-shiftcoverage`,
        'POST',
        { ...params }
      );
      dispatch(
        updateMultiShiftJobInfo({
          data: multiShiftsCoverageListing,
          page: page,
        })
      );
      // dispatch(setGridLoader(false));
      // dispatch(setLoading(false));
    } catch (error) {
      dispatch(shiftsCoverageFailed(error.message));
      // dispatch(setLoading(false));
      // dispatch(setGridLoader(false));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function loadCompletedShiftsCoverageListings({
  url,
  empId,
  pageToLoad,
}) {
  return async (dispatch, getState) => {
    // dispatch(setLoading(true));
    // dispatch(setGridLoader(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const state = getState();
      const { page, pageSize, sortOrder, sortColumn, filterFields } =
        state.shiftsCoverage;
      //shiftsType=1;
      let request = createLoadRequest(
        pageToLoad || page,
        pageSize,
        empId,
        filterFields.fromDate,
        filterFields.toDate,
        filterFields.location,
        filterFields.searchText,
        sortOrder,
        sortColumn,
        3
      );
      if (filterFields?.department?.length) {
        // request.departments = departments;
        request = { ...request, department: filterFields?.department?.map(deps => deps?.id) }
      }
      if (filterFields?.location?.length) {
        request = { ...request, LocationIdlist: filterFields?.location?.map(location => location?.id) }
      }
      const completedShiftsCoverageListing = await requestUtil(
        `${url}/Employers/get-completed-shift`,
        'POST',
        request
      );
      if (completedShiftsCoverageListing && completedShiftsCoverageListing?.jobShifts && completedShiftsCoverageListing?.jobShifts?.length) {
        completedShiftsCoverageListing.jobShifts.forEach((item, index) => {
          item.id = (index + 1) + (page - 1) * pageSize
        })
      }
      dispatch(
        updateCompletedShiftsCoverageListings({
          data: completedShiftsCoverageListing,
          page: pageToLoad || page,
        })
      );
      // dispatch(setLoading(false));
      // dispatch(setGridLoader(false));
    } catch (error) {
      dispatch(shiftsCoverageFailed(error.message));
      // dispatch(setLoading(false));
      // dispatch(setGridLoader(false));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function loadAwaitingShiftsCoverageListings({ url, empId, pageToLoad }) {
  return async (dispatch, getState) => {
    // dispatch(setLoading(true));
    // dispatch(setGridLoader(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const state = getState();
      const { page, pageSize, sortOrder, sortColumn, filterFields } =
        state.shiftsCoverage;
      //shiftsType=1;
      let request = createLoadRequest(
        pageToLoad || page,
        pageSize,
        empId,
        filterFields.fromDate,
        filterFields.toDate,
        filterFields.location,
        filterFields.searchText,
        sortOrder,
        sortColumn,
        4
      );
      if (filterFields?.department?.length) {
        // request.departments = departments;
        request = { ...request, department: filterFields?.department?.map(deps => deps?.id) }
      }
      if (filterFields?.location?.length) {
        request = { ...request, LocationIdlist: filterFields?.location?.map(location => location?.id) }
      }
      const awaitingShiftsCoverageListing = await requestUtil(
        `${url}/Employers/get-shift-awaiting-approval-v2`,
        'POST',
        request
      );
      if (awaitingShiftsCoverageListing && awaitingShiftsCoverageListing?.jobShifts && awaitingShiftsCoverageListing?.jobShifts?.length) {
        awaitingShiftsCoverageListing.jobShifts.forEach((item, index) => {
          item.id = (index + 1) + (page - 1) * pageSize
        })
      }
      dispatch(
        updateAwaitingShiftsCoverageListings({
          data: awaitingShiftsCoverageListing,
          page: pageToLoad || page,
        })
      );
      // dispatch(setLoading(false));
      // dispatch(setGridLoader(false));
    } catch (error) {
      dispatch(shiftsCoverageFailed(error.message));
      // dispatch(setLoading(false));
      // dispatch(setGridLoader(false));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function nextPage() {
  return async (dispatch, getState) => {
    const state = getState();
    const { page, pageSize, data } = state.shiftsCoverage;
    const lastPage = Math.ceil(data.totalCount / pageSize);
    dispatch(
      setPage({
        page: page + 1 > lastPage ? lastPage : page + 1,
      })
    );
  };
}
export function firstPage() {
  return async (dispatch) => {
    dispatch(
      setPage({
        page: 1,
      })
    );
  };
}
export function gotoPage(pageNumber) {
  return async (dispatch) => {
    dispatch(
      setPage({
        page: pageNumber,
      })
    );
  };
}
export function previousPage() {
  return async (dispatch, getState) => {
    const state = getState();
    const { page } = state.shiftsCoverage;
    dispatch(
      setPage({
        page: page - 1 < 1 ? 1 : page - 1,
      })
    );
  };
}
export function lastPage() {
  return async (dispatch, getState) => {
    const state = getState();
    const { pageSize, data } = state.shiftsCoverage;
    const lastPage = Math.ceil(data.totalCount / pageSize);
    dispatch(
      setPage({
        page: lastPage,
      })
    );
  };
}
export function setPageSize(size) {
  return async (dispatch) => {
    dispatch(
      updatePageSize({
        pageSize: size,
      })
    );
  };
}

export function updateSort(order, column) {
  return async (dispatch) => {
    dispatch(
      setSorting({
        sortOrder: order,
        sortColumn: column,
      })
    );
  };
}

export function loadMasterDatas(url, employerId) {
  return async (dispatch, getState) => {
    const state = getState();
    const locationDashboardSharedList = state.shared.locationDashboardSharedList;
    if(locationDashboardSharedList?.length > 0){
      dispatch(updateMasterDatas({ locationList:locationDashboardSharedList }));
      return
    }
    try {
    dispatch(setLoadingFlagIncrement());
      const locationList = await requestUtil(
        `${url}/Locations/get-location-list-for-dropdown/${employerId}`,
        'GET'
      );
      const allLocationList = [{id: 0, name: "All"},...locationList]
      dispatch(updateMasterDatas({ locationList }));
      dispatch(updateSharedSlice({name:'locationDashboardSharedList',value:allLocationList}));
      dispatch(updateSharedSlice({name:'locationSharedList',value:locationList}));
      dispatch(setHeaderState({name:"locationMasterList",value:locationList}));
      // dispatch(setLoading(false));
    } catch (error) {
      dispatch(shiftsCoverageFailed(error.message));
      // dispatch(setLoading(false));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}
export function updateFilterFields(fieldName, value) {
  return async (dispatch) => {
    dispatch(setFilterData({ fieldName, value }));
  };
}
export function clearFilter() {
  return async (dispatch) => {
    dispatch(updateClearFilter());
  };
}
export function patchFilterData(filterFields) {
  return async (dispatch) => {
    dispatch(patchFilterFieldData(filterFields));
  };
}

export function editPost() {
  return async (dispatch) => {
    dispatch(
      setSelectedOption({
        newPost: false,
        fromTemplate: false,
        createTemplate: false,
        editJobPost: true,
      })
    );
  };
}

export const deleteJob = ({ url, params }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(`${url}`, 'POST', { ...params });
      if (response.result === 1) {
        Toasts.success(response.message);
      } else if (response.result === 0) {
        Toasts.warning(response.message);
      }
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
    //  dispatch(setLoading(false));
  };
};

export const UnclaimedbyEmployerApi = ({ url, params }) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(`${url}`, 'POST', { ...params });
      if (response.result === 1) {
        Toasts.success(response.message);
      } else if (response.result > 1) {
        Toasts.success(response.message);
      } else if (response.result === 0) {
        Toasts.warning(response.message);
      }
    } catch (error) {
      Toasts.error(error.message);
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
    //  dispatch(setLoading(false));
  };
};
export const clearData = () => {
  return async (dispatch) => {
    dispatch(reset());
  };
};

export const editSaveTimeOccurrence = (url, params,shiftType) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(`${url}`, 'POST', { ...params });
      // dispatch(setLoading(false));
      const res = {
        jobShiftUniqueId: response?.jobsShiftUniqueId,
        locationUniqueId: response?.locationUniqueId,
        acceptableTravelDistance: response?.acceptableTravelDistance,
        jobsClaimId: response?.jobsClaimId,
        navigateMatchingCandidate: true,
        editJobUniqueId: response?.jobUniqueId,
      };
      Toasts.success(response.message);
      if(+shiftType === shiftTypeObj.dailyEnocunter){
        const payload = {
          jobUniqueId:response?.jobUniqueId,
          encounterId:"",
          jobShiftUniqueId:response?.jobsShiftUniqueId
        };
        return payload
      }
      dispatch(setMatchincandidateInfo(res));
    } catch (error) {
      if (error.message) {
        Toasts.warning(error.message);
      } else {
        Toasts.warning(error);
      }
      dispatch(setError(error.message));
      // dispatch(setLoading(false));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
    //  dispatch(setLoading(false));
  };
};

export const resetMatchingCandidateInfo = () => {
  return async (dispatch) => {
    const res = {
      jobShiftUniqueId: '',
      locationUniqueId: '',
      acceptableTravelDistance: '',
      jobsClaimId: 0,
      navigateMatchingCandidate: false,
      editJobUniqueId: '',
    };
    dispatch(setMatchincandidateInfo(res));
  };
};

export const multishiftFlag = (flag) => {
  return async (dispatch) => {
    dispatch(setMultishiftClaimedFalg(flag));
  };
};

export const getMultiShiftDetail = (url, params) => {
  //console.log('url', url);
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(
        `${url}/Employers/attempt-delete-multishift`,
        'POST',
        { ...params }
      );
      //console.log(response);
      dispatch(setMultishiftClaimDeail(response));
      // dispatch(multishiftFlag(true));
      // dispatch(setLoading(false));
    } catch (error) {
      dispatch(setError(error.message));
      // dispatch(setLoading(false));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const DeleteMultiShiftJob = (url, params) => {
  //console.log('url', url);
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(
        `${url}/Employers/delete-multishift-details`,
        'POST',
        { ...params }
      );
      //console.log(response);
      Toasts.success(response.message);
      // if (response.result === 1) {
      //   Toasts.success(response.message);
      // } else if (response.result === 0) {
      //   Toasts.warning(response.message);
      // }
      // dispatch(setLoading(false));
    } catch (error) {
      Toasts.error(error.message);
      dispatch(setError(error.message));
      // dispatch(setLoading(false));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};
// export const UnclaimMultiShiftJob = (url, params) => {
//   //console.log('url', url);
//   return async (dispatch) => {
//     dispatch(setLoading(true));
//     try {
//       const response = await requestUtil(`${url}/Jobs/unclaim-multishift-by-employer`, 'POST', { ...params });
//       //console.log(response);
//       Toasts.success(response.message);
//       dispatch(setLoading(false));
//     } catch (error) {
//       Toasts.error(error.message);
//       dispatch(setError(error.message));
//       dispatch(setLoading(false));
//     }
//   }
// }

export const DeleteMultiShiftJobOccurence = (url, params) => {
  //console.log('url', url);
  return async (dispatch) => {
    // dispatch(setLoading(true));

    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(
        `${url}/Employers/delete-single-occurrence-details`,
        'POST',
        { ...params }
      );
      //console.log(response);
      Toasts.success(response.message);
      // dispatch(setLoading(false));
    } catch (error) {
      Toasts.error(error.message);
      dispatch(setError(error.message));
      // dispatch(setLoading(false));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const UnclaimMultiShiftJob = (url, params) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(
        `${url}/Employers/unclaimMultishift`,
        'POST',
        { ...params }
      );
      Toasts.success(response.message);
      // dispatch(setLoading(false));
    } catch (error) {
      Toasts.error(error.message);
      dispatch(setError(error.message));
      // dispatch(setLoading(false));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const multishiftUnClaimByEmpFlag = (flag) => {
  return async (dispatch) => {
    dispatch(setMultishiftUnClaimByEmpFalg(flag));
  };
};

export const getUnClaimEmployerReasons = (url) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await requestUtil(
        `${url}/Employers/get-unclaim-employer-reasons`,
        'GET'
      );
      dispatch(setLoading(false));
      dispatch(setUnclaimEmployerReasons(response));
    } catch (error) {
      dispatch(setError(error.message));
    }
  };
};

export function loadMasterData(baseUrl, jobShiftUniqueId, empId) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const getAppointmentData = await requestUtil(
        `${baseUrl}/Dropdown/getappointmenttype?EmployerUniqueId=${empId}`,
        'GET'
      );
      const getShiftLengthData = await requestUtil(
        `${baseUrl}/Dropdown/getshiftlength`,
        'GET'
      );
      const getapprovedcandidates = await requestUtil(
        `${baseUrl}/EmployersEncounter/approvedcandidates/${jobShiftUniqueId}`,
        'GET'
      );
      const candidate = [];
      if (getapprovedcandidates?.length > 0) {
        getapprovedcandidates.forEach((item) => {
          candidate.push({
            value: item.candidateUniqueId,
            label: item.candidateFullName,
          });
        });
      }
      //console.log(candidate);

      dispatch(
        setCalenderData({
          appointmentData: getAppointmentData,
          shiftLengthData: getShiftLengthData,
          approvedcandidates: candidate,
        })
      );
    } catch (error) {
      dispatch(
        setFailureLogs(error.message || 'Error while loading master data')
      );
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function loadDailyEncounterInfo({ url, shiftUniqueId, jobUniqueId }) {
  return async (dispatch, getState) => {
    dispatch(setLoadingFlagIncrement());

    try {
      const state = getState();
      const { page, pageSize } = state.shiftsCoverage;
      //shiftsType=1;
      const request = {
        page: page,
        pageSize: pageSize,
        sortOrder: 'string',
        sortColumn: 'string',
        shiftUniqueId: shiftUniqueId,
        jobUniqueId: jobUniqueId,
      };

      const dailyEncounterInfo = await requestUtil(
        `${url}/Employers/open-shifts-encounter-occurences`,
        'POST',
        request
      );
      dispatch(
        updateDailyEncounterInfo({
          data: dailyEncounterInfo,
          page: page,
        })
      );
      if (
        dailyEncounterInfo?.resources &&
        dailyEncounterInfo?.resources.length
      ) {
        const groupArray = [
          ...new Set(
            dailyEncounterInfo?.resources.map((element, index) => {
              return element.name;
            })
          ),
        ];

        dispatch(setGrouping({ key: 'group', value: groupArray }));
        dispatch(
          setGrouping({
            key: 'resources',
            value: dailyEncounterInfo?.resources,
          })
        );
      }
      if (
        dailyEncounterInfo?.patientEncounterOccurrencesJson &&
        dailyEncounterInfo?.patientEncounterOccurrencesJson.length
      ) {
        dispatch(
          setJobEncounterOccurreneUpdateList(
            JSON.parse(
              JSON.stringify(
                dailyEncounterInfo?.patientEncounterOccurrencesJson.map(
                  (element, index) => {
                    return {
                      Start: element.start,
                      End: element.end,
                      isAllDay: element.isAllDay,
                      // Title: element.title,
                      AppointmentType: element.appointmentType,
                      ShiftLength: element.shiftLength,
                      PatientName: element.patientName,
                      PatientPhone: element.patientPhone,
                      PatientStreetAddress: element.patientStreetAddress,
                      PatientZipCode: element.patientZipCode,
                      // MapDetails: element.mapDetails,
                      TaskID: element.taskId,
                      PatientState: element.patientState,
                      PatientCity: element.patientCity,
                      billingRate: element.billingRate,
                      jobsClaimId: element.jobsClaimId
                        ? element.jobsClaimId
                        : null,
                      isUnclaimedOccurrence: element.isUnclaimedOccurrence,
                      ShiftUniqueId: element.shiftUniqueId,
                      candidateUniqueId: element.candidateUniqueId,
                      IsClaimed: element.isClaimed,
                      occurrenceCorrectionType: element?.occurrenceCorrectionType,
                      isCheckedOut: element?.isCheckedOut,
                    };
                  }
                )
              )
            )
          )
        );
      }
      if (
        dailyEncounterInfo?.jobInfoForDailyOccurance &&
        dailyEncounterInfo?.jobInfoForDailyOccurance.length
      ) {
        dispatch(
          setJobInfoForDailyOccurance(
            JSON.parse(
              JSON.stringify(dailyEncounterInfo?.jobInfoForDailyOccurance)
            )
          )
        );
      }
    } catch (error) {
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

// Get for Delete Reasons
export const getDeleteEmployerReasons = (url) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await requestUtil(
        `${url}/Dropdown/getdeletereasons`,
        'GET'
      );
      dispatch(setLoading(false));
      dispatch(setDeleteEmployerReasons(response));
    } catch (error) {
      dispatch(setError(error.message));
    }
  };
};

export const updateDailyEncounter = (url, requestJson) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await requestUtil(
        `${url}/EmployersEncounter/update`,
        'POST',
        { ...requestJson }
      );
      Toasts.success(response.message);
      dispatch(setLoading(false));
    } catch (error) {
      Toasts.error(error?.message);
      dispatch(setError(error.message));
    }
  };
};

export const addNewEncounterOccurence = (url, requestJson) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await requestUtil(
        `${url}/EmployersEncounter/add-new-encounter-occurrence`,
        'POST',
        { ...requestJson }
      );
      Toasts.success(response.message);
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      Toasts.error(error?.message);
      dispatch(setError(error.message));
      return error;
    }
  };
};

export const updateEncounterOccurence = (url, requestJson) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    const state = getState();
    const { JobEncounterOccurreneUpdateList } = state.jobOpportunity;
    const newVal = JSON.parse(JSON.stringify(JobEncounterOccurreneUpdateList));
    try {
      const response = await requestUtil(
        `${url}/EmployersEncounter/update-encounter-occurrences`,
        'POST',
        { ...requestJson }
      );

      const index = newVal?.findIndex(val => val.TaskID === response?.taskId)
      const filter = newVal?.filter(val => val.TaskID === response?.taskId)
        .map(val2 => { return { ...val2, ShiftUniqueId: response?.shiftUniqueId, jobsClaimId: response?.jobsClaimId } });
      if (response?.shiftUniqueId && +response?.jobsClaimId > 0) {
        if (index !== -1) {
          newVal.splice(index, 1, ...filter);
          dispatch(
            setJobEncounterOccurreneUpdateList(JSON.parse(JSON.stringify(newVal)))
          );
        }
      }

      Toasts.success(response.message);
      dispatch(setLoading(false));
      return response;
    } catch (error) {
      Toasts.error(error?.message);
      dispatch(setError(error.message));
      return error;
    }
  };
};

export const deleteEncounterOccurence = (url, requestJson) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const response = await requestUtil(
        `${url}/EmployersEncounter/delete-encounter-occurrences`,
        'POST',
        { ...requestJson }
      );
      Toasts.success(response.message);
      dispatch(setLoading(false));
    } catch (error) {
      Toasts.error(error?.message);
      dispatch(setError(error.message));
    }
  };
};

export const getFilterDailyEncounter = (url, requestJson) => {
  return async (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setLoadingFlagIncrement());

    try {
      const response = await requestUtil(
        `${url}/EmployersEncounter/scheduledencounters`,
        'POST',
        { ...requestJson }
      );
      if (
        response?.EncounterOccurences &&
        response?.EncounterOccurences.length
      ) {
        dispatch(
          setJobEncounterOccurreneUpdateList(JSON.parse(JSON.stringify([])))
        );
        dispatch(setGrouping({ key: 'group', value: [] }));
        dispatch(setGrouping({ key: 'resources', value: [] }));

        dispatch(
          setJobEncounterOccurreneUpdateList(
            JSON.parse(
              JSON.stringify(
                response?.EncounterOccurences.map((element, index) => {
                  return {
                    Start: element.start,
                    End: element.end,
                    isAllDay: element.isAllDay,
                    // Title: element.title,
                    AppointmentType: element.appointmentType,
                    ShiftLength: element.shiftLength,
                    PatientName: element.patientName,
                    PatientPhone: element.patientPhone,
                    PatientStreetAddress: element.patientStreetAddress,
                    PatientZipCode: element.patientZipCode,
                    // MapDetails: element.mapDetails,
                    TaskID: element.taskId,
                    PatientState: element.patientState,
                    PatientCity: element.patientCity,
                    billingRate: element.billingRate,
                    jobsClaimId: element.jobsClaimId
                      ? element.jobsClaimId
                      : null,
                    isUnclaimedOccurrence: element.isUnclaimedOccurrence,
                    ShiftUniqueId: element.shiftUniqueId,
                    candidateUniqueId: element.candidateUniqueId,
                    IsClaimed: element.isClaimed,
                    occurrenceCorrectionType: element?.occurrenceCorrectionType,
                    isCheckedOut: element?.isCheckedOut,
                  };
                })
              )
            )
          )
        );
      }
      // dispatch(setLoading(false));
      return response.Resources;
    } catch (error) {
      Toasts.error(error?.message);
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export const deleteAllMultishiftOccurrence = (url, jobsShiftUniqueId) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const params = {
        jobsShiftUniqueId,
      };
      const response = await requestUtil(
        `${url}/Employers/force-delete-all-job`,
        'POST',
        { ...params }
      );
      if (response?.result === 1) {
        Toasts.success(response.message);
      } else if (response?.result === 0) {
        Toasts.warning(response.message);
      }
      return response;
    } catch (error) {
      Toasts.error(error.message);
      dispatch(setError(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};

export function multishiftJoinFilterData(url) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const filterData = await requestUtil(
        `${url}/Employers/get-multishift-jobinfofilterdata-fordropdown`,
        'GET'
      );
      dispatch(updateMultiShiftFilterData(filterData));
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getEmailDetails({ url }) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "GET");
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function sendEmail({ url, params }) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      Toasts.success("Email sent successfully!");
      return response;
    } catch (error) {
      Toasts.error("Email not sent!");
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getSMSDetails({ url, params }) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function sendSMS({ url, params }) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(`${url}`, "POST", { ...params });
      Toasts.success("Sms sent successfully!");
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function sendAllEmailbtn(url) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await fetch(url);
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function sendAllSmsbtn(url) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await fetch(url);
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}

export function getCallHistory(url, params) {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(
        `${url}/Voice/get-recordings`,
        'POST', params
      );;
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
};


export const getJobDepartmentList = ({ url }) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const response = await requestUtil(url);
      return response;
    } catch (error) {
      return error.message;
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  }
}

export const fetchDollarDetails = ({ url, params }) => {
  return async (dispatch) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const result = await requestUtil(url, "POST", { ...params });
      if (result?.result) {
        return result?.candidatePayRateSetupList
      }
    } catch (error) {
      return error
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  }
}


export function loadShiftAwaitingCorrection({ url, empId, pageToLoad }) {
  return async (dispatch, getState) => {
    dispatch(setLoadingFlagIncrement());
    try {
      const state = getState();
      const { page, pageSize, sortOrder, sortColumn, filterFields } =
        state.shiftsCoverage;
      let request = createLoadRequest(
        pageToLoad || page,
        pageSize,
        empId,
        filterFields.fromDate,
        filterFields.toDate,
        filterFields.location,
        filterFields.searchText,
        sortOrder,
        sortColumn,
        6
      );
      if (filterFields?.department?.length) {
        request = { ...request, department: filterFields?.department?.map(deps => deps?.id) }
      }
      if (filterFields?.location?.length) {
        request = { ...request, LocationIdlist: filterFields?.location?.map(location => location?.id) }
      }
      const openShiftsCoverageListing = await requestUtil(
        `${url}/Employers/get-shift-awaiting-corrections`,
        'POST',
        request
      );
      if (openShiftsCoverageListing && openShiftsCoverageListing?.jobShifts && openShiftsCoverageListing?.jobShifts?.length) {
        openShiftsCoverageListing.jobShifts.forEach((item, index) => {
          item.id = (index + 1) + (page - 1) * pageSize
        })
      }
      dispatch(
        updateShiftsCorrectionsListings({
          data: openShiftsCoverageListing,
          page: pageToLoad || page,
        })
      );
    } catch (error) {
      dispatch(shiftsCoverageFailed(error.message));
    } finally {
      dispatch(setLoadingFlagDecrement());
    }
  };
}
